module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/quote-7d204ec3bbbb29c04c54d5743fa18b6e.svg";